import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import PageTitle from "../../../../Displays/PageTitle";
import { SMART_CHARGING_PATHS } from "src/consts/Routes/SmartCharging";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import PageSubTitle from "../../../../Displays/PageSubTitle";
import VerticalLinearProgress, {
  progressMenuSx,
  stepProgressProps,
} from "../../../VerticalLinearProgressBar";

const STEPS = [
  "Start",
  "Wallbox verbinden",
  "Einstellungen überprüfen",
  "Verbindung herstellen",
  "Status",
] as const;

export const tariffCalculator = (pathname: string) => {
  switch (pathname) {
    case SMART_CHARGING_ROUTES.INTRO:
      return 95;
    case SMART_CHARGING_ROUTES.ONBOARDING_SLIDER:
      return 95;
    case SMART_CHARGING_ROUTES.CONNECT_CONFIRM:
      return 115;
    case SMART_CHARGING_ROUTES.CONNECTING:
      return 135;
    case SMART_CHARGING_ROUTES.CONNECTING_SUCCESS:
      return 155;
    case SMART_CHARGING_ROUTES.CONNECTING_ERROR:
      return 155;
    default:
      return 70;
  }
};

const activeStep = (pathname: string) => {
  switch (pathname) {
    case SMART_CHARGING_ROUTES.INTRO:
    case SMART_CHARGING_ROUTES.ONBOARDING_SLIDER:
      return 2;
    case SMART_CHARGING_ROUTES.CONNECT_CONFIRM:
      return 3;
    case SMART_CHARGING_ROUTES.CONNECTING:
      return 4;
    case SMART_CHARGING_ROUTES.CONNECTING_SUCCESS:
    case SMART_CHARGING_ROUTES.CONNECTING_ERROR:
      return 5;
    default:
      return 1;
  }
};

const SmartChargingOnboardingProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack gap="13px" sx={progressMenuSx}>
      <PageTitle text={"Menü"} />
      {SMART_CHARGING_PATHS.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 155,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={155 - tariffCalculator(pathname)}
            {...stepProgressProps(STEPS, activeStep(pathname))}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            {STEPS.map((text) => (
              <PageSubTitle key={text} text={text} />
            ))}
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SmartChargingOnboardingProgressBar;
